const SvgArrowDown = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M8.33002 2.99544C8.2421 2.99752 8.15856 3.03426 8.0976 3.09766L4.99995 6.19531L1.90229 3.09766C1.87123 3.06572 1.83408 3.04034 1.79304 3.02301C1.752 3.00568 1.70791 2.99675 1.66336 2.99674C1.59705 2.99676 1.53225 3.01656 1.47724 3.05359C1.42224 3.09063 1.37953 3.14323 1.35458 3.20467C1.32963 3.26611 1.32356 3.33359 1.33717 3.39849C1.35077 3.46339 1.38342 3.52276 1.43094 3.56901L4.76427 6.90234C4.82678 6.96483 4.91156 6.99994 4.99995 6.99994C5.08834 6.99994 5.17311 6.96483 5.23562 6.90234L8.56896 3.56901C8.61736 3.52246 8.65058 3.46237 8.66426 3.39662C8.67794 3.33087 8.67145 3.26252 8.64562 3.20052C8.6198 3.13853 8.57585 3.08578 8.51953 3.04918C8.46322 3.01259 8.39716 2.99386 8.33002 2.99544Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default SvgArrowDown;
